<template>
  <div class="box">
    <div class="login-box">
      <h2>个人博客后台</h2>
      <div class="form-box">
        <el-form ref="loginForm" :model="form" label-width="0px" :rules="rules">
          <el-form-item label="" prop="username">
            <el-input v-model="form.username" placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              v-model="form.password"
              placeholder="密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="identifyCode">
            <div class="code-box">
              <el-input
                v-model="form.identifyCode"
                placeholder="验证码"
              ></el-input>
              <div @click="refreshCode()" class="code">
                <sIdentify :identifyCode="identifyCode"></sIdentify>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('loginForm')"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import sIdentify from "@/common/sIdentify.vue";
export default {
  components: { sIdentify },
  data() {
    return {
      //验证码
      identifyCode: "",
      identifyCodes: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
      ], //根据实际需求加入自己想要的字符
      form: {
        username: "",
        password: "",
        identifyCode: "",
      },
      rules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
          {
            min: 4,
            max: 12,
            message: "用户名长度在 4 到 12 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "密码长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        identifyCode: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
          {
            min: 4,
            max: 4,
            message: "验证码长度为4个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$message.error("登录失败");
          return false;
        }
        if (this.form.identifyCode != this.identifyCode) {
          this.$message.error("验证码错误");
          this.refreshCode();
          return false;
        }
        const { data: res } = await this.$axios.post("/login", this.form);
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
        this.$message.success(res.meta.msg);
        window.sessionStorage.setItem("token", "12312312313");
        this.$router.push("/index");
        console.log(res);
      });
    },
    // 生成随机数
    randomNum(min, max) {
      max = max + 1;
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 更新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 随机生成验证码字符串
    makeCode(data, len) {
      for (let i = 0; i < len; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length - 1)];
      }
    },
  },
  mounted() {
    this.refreshCode();
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  background-image: url(../assets/img/bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: inherit;
  filter: blur(3px);
  z-index: 2;
}

.login-box {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%);
  z-index: 3;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.7);
  text-align: center;
  padding: 20px;

  .form-box {
    margin: 0 20px;

    .code-box {
      display: flex;
      align-items: center;
      line-height: 0px !important;

      .code {
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }

  .el-form-item {
    width: 320px;
  }

  .el-button {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue